import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
const Container = styled.svg`
  cursor: pointer;
  &:hover {
    fill: #1570ef;
    path {
      fill: #fff;
    }
  }
`;

function RectangleListRegular({ rowId }) {
  const navigate = useNavigate();
  return (
    <span style={{ padding: "5px" }}>
      <Container
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        onClick={() => {
          navigate(`/ReferralEditData?rowId=${rowId}`);
        }}
      >
        <rect
          x="0.5"
          y="0.5"
          width="23"
          height="23"
          rx="2.5"
          stroke="#057AFF"
        />
        <path
          d="M6 9.28571C6 8.57656 6.59792 8 7.33333 8H16.6667C17.4021 8 18 8.57656 18 9.28571V15.7143C18 16.4234 17.4021 17 16.6667 17H7.33333C6.59792 17 6 16.4234 6 15.7143V9.28571ZM8.66667 13.1429C9.03542 13.1429 9.33333 12.8556 9.33333 12.5C9.33333 12.1444 9.03542 11.8571 8.66667 11.8571C8.29792 11.8571 8 12.1444 8 12.5C8 12.8556 8.29792 13.1429 8.66667 13.1429ZM9.33333 10.5714C9.33333 10.2158 9.03542 9.92857 8.66667 9.92857C8.29792 9.92857 8 10.2158 8 10.5714C8 10.927 8.29792 11.2143 8.66667 11.2143C9.03542 11.2143 9.33333 10.927 9.33333 10.5714ZM8.66667 15.0714C9.03542 15.0714 9.33333 14.7842 9.33333 14.4286C9.33333 14.073 9.03542 13.7857 8.66667 13.7857C8.29792 13.7857 8 14.073 8 14.4286C8 14.7842 8.29792 15.0714 8.66667 15.0714ZM10.6667 10.0893C10.3896 10.0893 10.1667 10.3042 10.1667 10.5714C10.1667 10.8386 10.3896 11.0536 10.6667 11.0536H15.3333C15.6104 11.0536 15.8333 10.8386 15.8333 10.5714C15.8333 10.3042 15.6104 10.0893 15.3333 10.0893H10.6667ZM10.6667 12.0179C10.3896 12.0179 10.1667 12.2328 10.1667 12.5C10.1667 12.7672 10.3896 12.9821 10.6667 12.9821H15.3333C15.6104 12.9821 15.8333 12.7672 15.8333 12.5C15.8333 12.2328 15.6104 12.0179 15.3333 12.0179H10.6667ZM10.6667 13.9464C10.3896 13.9464 10.1667 14.1614 10.1667 14.4286C10.1667 14.6958 10.3896 14.9107 10.6667 14.9107H15.3333C15.6104 14.9107 15.8333 14.6958 15.8333 14.4286C15.8333 14.1614 15.6104 13.9464 15.3333 13.9464H10.6667Z"
          fill="#057AFF"
        />
      </Container>
    </span>
  );
}

export default RectangleListRegular;
